export var ChipStatus;
(function (ChipStatus) {
    ChipStatus[ChipStatus["Available"] = 1] = "Available";
    ChipStatus[ChipStatus["ComingSoon"] = 2] = "ComingSoon";
})(ChipStatus || (ChipStatus = {}));
//# sourceMappingURL=ChipStatus.js.map